import { render, staticRenderFns } from "./modalRegion.vue?vue&type=template&id=754b422a&scoped=true"
import script from "./modalRegion.vue?vue&type=script&lang=js"
export * from "./modalRegion.vue?vue&type=script&lang=js"
import style0 from "./modalRegion.vue?vue&type=style&index=0&id=754b422a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b422a",
  null
  
)

export default component.exports